import React from "react";

export const SelectArrow = () => (
  <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1.125L4 3.875L1 1.125" stroke="#01054C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

const FilterSelect = ({ id, label, value, onChange, options, disabled, className = "" }) => (
  <div className={className}>
    {label && (
      <label htmlFor={id} className="mb-1 block text-xs text-[#1A2B49]">
        {label}
      </label>
    )}
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`h-11 w-full appearance-none rounded-md border border-[#C8CED8] bg-white px-3 pr-10 text-[15px] font-semibold text-[#1A2B49] outline-none${disabled ? " cursor-not-allowed opacity-60" : ""}`}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <SelectArrow />
    </div>
  </div>
);

export default FilterSelect;
